import { motion } from "framer-motion";
import { useLang } from "@/landing/LanguageContext";
import { trackLead } from "@/landing/pixel";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "", dark = false }) => {
  if (!children) return null;
  return (
    <span
      className={`inline-block font-sans text-xs tracking-[0.32em] uppercase ${
        dark ? "text-sand" : "text-earth"
      } ${className}`}
    >
      {children}
    </span>
  );
};

// Primary CTA — always links to WhatsApp
export const CTAButton = ({ children, testid, source, variant = "solid", className = "" }) => {
  const { wa } = useLang();
  const base =
    "group inline-flex items-center justify-center gap-3 rounded-full px-8 py-4 font-sans text-xs sm:text-sm tracking-[0.18em] uppercase transition-all duration-300 cursor-pointer";
  const styles = {
    solid: "bg-carbon text-cream hover:bg-earth",
    light: "bg-cream text-carbon hover:bg-sand",
    outline: "border border-carbon/40 text-carbon hover:bg-carbon hover:text-cream",
    outlineLight: "border border-cream/40 text-cream hover:bg-cream hover:text-carbon",
  };
  return (
    <a
      href={wa}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      onClick={() => trackLead(source || testid)}
      className={`${base} ${styles[variant]} ${className}`}
    >
      <span>{children}</span>
      <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
    </a>
  );
};

export const WhatsTag = ({ dark = false }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs tracking-[0.18em] uppercase ${
      dark ? "text-sand/80" : "text-earth/80"
    }`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-current animate-pulse" />
    WhatsApp
  </span>
);
